import styled from "styled-components";
import theme from "../../../../Styles/theme";
export const Container = styled.div`
  display: flex;
  flex-direction: column;

`;